import { memo } from "react";

import { Loader } from "@/components/Loading";

import { useForm } from "../../hooks/useForm";
import type { FieldId, FieldValueType, SelfServiceTaskForm } from "../../types";

interface FormContainerProps {
  /** フォーム定義 */
  formDefinition: SelfServiceTaskForm;
  /** 初期値 */
  initialValues?: Record<FieldId, FieldValueType>;
  /** 読み取り専用モード */
  readOnly?: boolean;
  /** テストID */
  "data-testid"?: string;
  /** クラス名 */
  className?: string;
  /** ローディング中に表示するコンポーネント */
  LoadingComponent?: React.ComponentType;
  /** 子コンポーネント */
  children?: React.ReactNode;
}

/**
 * フォームコンテナコンポーネント
 *
 * フォームの表示と状態管理を行います。
 * FormWrapperまたはFormRenderer経由での使用を想定しています。
 */
export const FormContainer = memo(
  ({
    formDefinition,
    initialValues,
    readOnly = false,
    className,
    "data-testid": testId,
    children,
  }: FormContainerProps) => {
    const { initialized } = useForm({
      formDefinition,
      initialValues,
    });

    return (
      <div
        className={`form-factory-form space-y-4 ${className || ""}`}
        data-testid={testId}
        data-form-id={formDefinition?.form?.id || ""}
        aria-readonly={readOnly}
      >
        {initialized ? (
          <div className="form-content">{children}</div>
        ) : (
          <Loader />
        )}
      </div>
    );
  },
);

FormContainer.displayName = "FormContainer";
